import React from 'react';
import './Timer.css';

/**
 * `penaltyFlash` is the number of seconds an assist just added. It floats up
 * and fades so the cost is visible at the moment it is paid — a clock that
 * silently jumped forward would feel like a bug rather than a price.
 */
const Timer = ({ timer, formatTime, penaltyFlash }) => (
  <div className="timer">
    {formatTime(timer)}
    {penaltyFlash != null && (
      <span key={penaltyFlash + '-' + timer} className="timer-penalty" aria-live="polite">
        +{penaltyFlash}s
      </span>
    )}
  </div>
);

export default Timer;
